import { cn } from '@/lib/cn';
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('bg-paper-rec rounded-md animate-pulse', className)} />;
}
